import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { ICUIAppStyles } from "./CUIApp.types"

export const CUIAppStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<ICUIAppStyles>
> = (theme: IPartialTheme) => ({
    loadingRoot: {
        background: theme.semanticColors?.bodyBackground
    },
    centered: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden"
    },
    infoText: {
        display: "block",
        color: theme.palette?.neutralDark,
        fontStyle: "italic",
        textAlign: "center",
        marginBottom: "1em"
    },
    retryButton: {
        backgroundColor: theme.palette?.themeSecondary
    }
})
